export default "__VITE_ASSET__BVp3dqUX__"